import { useIntl } from 'react-intl';

import { useDeviceState, usePricesState } from '@/hooks/store';
import messages from '@/messages/messages';
import { Prices } from '@/store/prices/types';

import { useFormattedCurrency } from './useFormattedCurrency';

type UseFormattedPriceWithTax = (
	price: number,
	currency?: string,
	currencyDisplay?: Intl.NumberFormatOptions['currencyDisplay'],
) => string;

export const shouldShowTaxAmount = (countryCode: string | null | undefined, prices: Prices) => {
	const countriesToShowTaxIn = ['us', 'ca'];

	// this is primarily for local and dev environment testing - the logic won't directly match
	// until we fix maxmind returning correct country code on these environments
	if (!countryCode || countryCode === 'unknown' || countryCode === '') {
		return ['usd', 'cad'].includes(prices?.pricing_format?.currency.toLowerCase());
	}

	return countriesToShowTaxIn.includes(countryCode.toLowerCase());
};

export const useFormattedPriceWithTax: UseFormattedPriceWithTax = (price, currency, currencyDisplay) => {
	const formatCurrency = useFormattedCurrency();
	const { formatMessage } = useIntl();
	const device = useDeviceState();
	const prices = usePricesState();

	const priceWithCurrency = formatCurrency(price, currency, currencyDisplay);

	if (!shouldShowTaxAmount(device?.ip_country, prices) || price === 0) {
		return priceWithCurrency;
	}

	return `${priceWithCurrency} + ${formatMessage(messages.applicableTax)}`;
};
